export default __webpack_public_path__ + "static/ls-toronto-68de2f242dcf6df3f1967eee5a6f3b97.jpg";